// @ts-check

/** @type {QueryModuleState} */
export const queryState = {
  params: {}
}

/** @type {QueryGetterTree} */
export const queryGetters = {
  params: ({ params }) => params
}

/**
 * @type {QueryMutationTree}
 */
export const queryMutations = {
  resetFilterParams: (state) => {
    state.params = {}
  },
  /** @param {QueryModuleState['params']} params */
  setFilterParams: (state, params) => {
    state.params = { ...state.params, ...params }
  },
  /** @param {string} key */
  toggleTrueParam: (state, key) => {
    state.params = {
      ...state.params,
      [key]: state.params[key] === true ? undefined : true
    }
  },
  /** @param {string} key */
  toggleFalseParam: (state, key) => {
    state.params = {
      ...state.params,
      [key]: state.params[key] === false ? undefined : false
    }
  },

  removeFilterParam: (state, paramKey) => {
    if (paramKey === 'clear-params') {
      state.params = { orderby: state.params?.orderby }
      return
    }

    if (paramKey === 'clear-filters') {
      const params = { orderby: state.params?.orderby }

      if (state.params?.start_date) {
        params.start_date = state.params.start_date
      }
      if (state.params?.end_date) {
        params.end_date = state.params.end_date
      }
      if (state.params?.search) {
        params.search = state.params.search
      }
      if (state.params?.accounts) {
        params.accounts = state.params.accounts
      }

      state.params = params
      return
    }

    const params = { ...state.params }
    delete params[paramKey]

    state.params = params
  }
}
